var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { MediaLargerEqual, MediaSmaller } from '../../..';
import { AutosuggestInput } from '../../../forms';
import { typedBoolean } from '../../../utils/utils';
import { SearchInput, SearchIcon, SearchForm, ClearIcon } from './style';
var SearchBar = (function (_super) {
    __extends(SearchBar, _super);
    function SearchBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            query: _this.props.query || '',
            showClearButton: false
        };
        _this.componentDidUpdate = function (prevProps) {
            if (_this.props.query !== prevProps.query) {
                _this.setState({
                    query: _this.props.query
                });
            }
        };
        _this.onChange = function (e) {
            if (_this.props.controlled && _this.props.onChange) {
                return _this.props.onChange(e.target.value);
            }
            return _this.setState({
                query: e.target.value,
                showClearButton: typedBoolean(e.target.value)
            });
        };
        _this.autosuggestOnChange = function (e, _a) {
            var newValue = _a.newValue, method = _a.method;
            if (_this.props.controlled && _this.props.onChange) {
                return _this.props.onChange(newValue);
            }
            return _this.setState({
                query: newValue
            });
        };
        _this.onSubmit = function (event) {
            event.preventDefault();
            _this.props.onSubmit && _this.props.onSubmit(_this.state.query.trim());
        };
        _this.clearIcon = (_jsx(ClearIcon, { useSearchbarV2: _this.props.useSearchbarV2, customTheme: _this.props.customTheme, onClick: function (e) {
                var _a;
                _this.setState({ showClearButton: false, query: '' });
                (_a = _this.props) === null || _a === void 0 ? void 0 : _a.focusSearchBar();
                _this.props.logEvent &&
                    _this.props.logEvent('CLEAR_ICON_CLICKED', {
                        eventPosition: 'HEADER'
                    });
            } }));
        _this.searchIcon = (_jsx(SearchIcon, { useSearchbarV2: _this.props.useSearchbarV2, customTheme: _this.props.customTheme, onClick: function (e) {
                _this.onSubmit(e);
                _this.props.logEvent &&
                    _this.props.logEvent('SEARCH_ICON_CLICKED', {
                        eventPosition: 'HEADER'
                    });
            } }));
        return _this;
    }
    SearchBar.prototype.render = function () {
        var _a;
        var _b = this.props, withAutosuggest = _b.withAutosuggest, useSearchbarV2 = _b.useSearchbarV2, searchBarTestId = _b.searchBarTestId, customTheme = _b.customTheme;
        var searchInput = (_jsx(SearchInput, { useSearchbarV2: useSearchbarV2, type: "text", autoFocus: this.props.autoFocus, value: this.state.query, ref: this.props.innerRef, placeholder: this.props.placeholder, onChange: this.onChange, id: searchBarTestId, customTheme: customTheme }));
        return (_jsxs(SearchForm, __assign({ useSearchbarV2: useSearchbarV2, hidden: !!this.props.hidden, onSubmit: this.onSubmit, style: this.props.style, className: (_a = this.props.className) !== null && _a !== void 0 ? _a : '', customTheme: customTheme }, { children: [withAutosuggest ? (_jsx(AutosuggestInput, __assign({ name: "search", input: searchInput, onChange: this.autosuggestOnChange, value: this.state.query, setValue: function () { return 0; } }, __assign({ theme: {
                        container: {
                            width: '100%'
                        },
                        suggestionsContainer: {
                            marginTop: '0.5rem',
                            zIndex: '9999',
                            maxHeight: '480px',
                            overflowY: 'auto'
                        }
                    } }, withAutosuggest)))) : (searchInput), _jsx(MediaLargerEqual, __assign({ breakpoint: "small" }, { children: this.searchIcon })), _jsx(MediaSmaller, __assign({ breakpoint: "small" }, { children: this.state.showClearButton ? this.clearIcon : this.searchIcon }))] })));
    };
    return SearchBar;
}(React.Component));
export default SearchBar;
export { SearchInput, SearchIcon };
//# sourceMappingURL=index.js.map